var _switch;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep201(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 100 100",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    width: 1,
    height: 1,
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 49.9,
    r: 48.1,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.2 74.3c3-3.1 6-6.1 8.8-9s5.3-5.6 7.6-8.3c2.2-2.7 4-5.3 5.3-7.8s2-4.9 2-7.3c0-1-0.2-2-0.6-2.8s-0.9-1.5-1.5-2.1c-0.7-0.6-1.4-1-2.4-1.4-0.9-0.3-1.9-0.5-3.1-0.5-1.1 0-2.1 0.2-3 0.5s-1.6 0.7-2.2 1.3c-0.6 0.5-1 1.1-1.4 1.8-0.3 0.6-0.5 1.3-0.5 2 0 1.6 0.3 3 0.8 4.2s1.2 2.3 2.1 3.2l-6.6 6c-1.4-0.7-2.6-1.8-3.6-3.5-1-1.6-1.8-3.3-2.3-5.1s-0.8-3.3-0.8-4.5c0-2.7 0.7-5.3 2.2-7.7 1.5-2.5 3.7-4.5 6.6-6 2.9-1.6 6.4-2.4 10.5-2.4 3.4 0 6.3 0.8 8.8 2.3s4.5 3.5 5.9 6 2.1 5.1 2.1 7.9c0 2.2-0.3 4.3-1 6.4s-1.6 4.1-2.8 6.1-2.6 4-4.1 5.9-3.1 3.9-4.7 5.9l-5-1.4h18.1v10.3h-35.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep201);
export default __webpack_public_path__ + "static/media/step2-01.72959d75c9e685b53b1dbc2f8d8e6bc8.svg";
export { ForwardRef as ReactComponent };